import type { CreateTripInput, OrderDto, TripDto } from '@posilka/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

export const tripKeys = {
  mine: ['driver', 'trips'] as const,
  search: (from?: string, to?: string) => ['trips', from, to] as const,
};

/** Shafyorning o'z safarlari. */
export const useMyTrips = () =>
  useQuery({ queryKey: tripKeys.mine, queryFn: () => api<TripDto[]>('/driver/trips') });

/** Yuboruvchi: shu yo'nalishda ketayotgan, bo'sh joyi bor safarlar. */
export const useTripsSearch = (fromCityId?: string, toCityId?: string) =>
  useQuery({
    queryKey: tripKeys.search(fromCityId, toCityId),
    queryFn: () => api<TripDto[]>(`/trips?fromCityId=${fromCityId}&toCityId=${toCityId}`),
    enabled: !!fromCityId && !!toCityId && fromCityId !== toCityId,
    staleTime: 60_000,
  });

export const useCreateTrip = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Omit<CreateTripInput, 'departAt'> & { departAt: string }) =>
      api<TripDto>('/driver/trips', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: tripKeys.mine }),
  });
};

export const useCancelTrip = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api(`/driver/trips/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: tripKeys.mine }),
  });
};

/** Safar egasi taklifni rad etadi — buyurtma hammaga ochiladi. */
export const declineOffer = (orderId: string) =>
  api<OrderDto>(`/orders/${orderId}/decline-offer`, { method: 'POST' });
